import { Slide } from "@jelly/lesson";

import { task as task01 } from "../../../../../task/course-02/lesson-29/task-01";

const task: Slide = {
  titleHtml: "Indicate which non-auditory effects are related to noise exposure.",
  description: "Select the correct answer(s).",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task01.id,
        },
      },
    },
  },
};

export default task;
